<template>
    <div class="enterprise-container">
        <Banner :mode="'enterprise-center'" class="enterprise-banner-contaoner"></Banner>
        <RightsCard :deptVal="dept" :tokenVal="token" class="enterprise-right-card-container"></RightsCard>
        <!-- <div class="page-content-container">
            <div class="page-content-header">
                <div class="page-header-block"></div>
                <div class="page-content-header-item-active">我的学习</div>
            </div>
            <div class="page-content-wrapper">
                <div class="page-content">
                    <div class="page-title-wrapper">
                        <div class="page-title-item-active">录播 (45)</div>
                        <div class="page-title-item">直播</div>
                    </div>
                    <div class="page-mode-input-wrapper">
                        <div class="page-mode-input">
                            <el-input v-model="searchVal" placeholder="请输入搜索内容"></el-input>
                        </div>
                        <div class="input-btn" @click="handleSearch">
                            <i class="el-icon-search input-btn-icon"></i>
                            <span class="input-btn-label">搜索</span>
                        </div>
                    </div>
                    <div class="video-list">
                        <List :mode="listMode" :tableData="tableData"></List>
                        <div v-if="tableData.length>0 && currentPage<totalPages" class="view-more-btn" @click="viewMore">查看更多</div>
                    </div> 
                </div>
            </div>
        </div> --> 
    </div>
</template>

<script>
import { getRecordCourseList } from '@/api/index.js';
import Banner from '@/components/Banner.vue'
import RightsCard from '@/components/RightsCard.vue'
import List from '@/components/List.vue'
export default {
    name: '',
    components:{
      Banner,
      RightsCard,
      List
    },
    data() {
        return {
            dept:'',
            token:'',
            searchVal:"",
            listMode:"enterprise-center",
            tableData:[],
            currentPage:1,
            totalPages:1
        }
    },
    created(){
        // this.dept=this.$route.params.dept;
        // this.token=this.$route.params.token;
           this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
    },
    mounted(){
        this.tableData=[];
        this.getCourseList();
    },
    methods: {
        getCourseList(){
            getRecordCourseList({
                "deptId": this.dept,
                "keyword": this.searchVal,
                "pageNum": this.currentPage,
                "pageSize": 10,
                "userId": 0
            },{
                Authorization:this.token,
                DeptId:this.dept
            }).then(res => {
                if(res.code==200){
                    var data=res.data.list;
                    var tableArr=this.tableData;
                    this.tableData=tableArr.concat(data);
                    this.totalPages=res.data.totalPages;
                }
                return;
            }).catch(err => {
               // console.log(err);
            });
        },
        handleSearch(){
            this.tableData=[];
            this.currentPage=1;
            this.getCourseList();
        },
        viewMore(){
            var currentPage=this.currentPage;
            if(currentPage<this.totalPages){
                this.currentPage=currentPage+1;
                this.getCourseList();
            }else{
                this.$message({
                    message: '没有更多了',
                    type: 'warning'
                });
            }
        }
    }
}
</script>

<style scoped>
.enterprise-container{
    min-height:calc(100vh - 136px);
    display:flex;
    flex-direction: column;
}
.enterprise-banner-contaoner{
    height:260px;
}
.enterprise-right-card-container{
    flex:1;
    border:solid red 1px;
}
.page-content-container{
    width:100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin-top:18px;
}
.page-content-header{
    width:100%;
    height:80px;
    background: #F8FAFF;
    border-radius: 6px 5px 0px 0px;
    line-height:80px;
    position: relative;
}
.page-header-block{
    width:6px;
    height:24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left:0px;
    top:28px;
}
.page-content-header-item{
    width:170px;
    height:100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
}
.page-content-header-item:hover{
    color: #4F79ED;
    cursor:pointer;
}
.page-content-header-item-active{
    width:170px;
    height:100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor:pointer;
}
.page-content-wrapper{
    display:flex;
}
.page-content{
    flex:1;
    margin:42px 41px 30px 45px;
}
.page-title-wrapper{
    display:flex;
}
.page-title-item-active{
    width: 101px;
    height: 32px;
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-align:center;
    line-height:32px;
    cursor:pointer;
    margin-right:15px;
}
.page-title-item{
    width: 101px;
    height: 32px;
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align:center;
    line-height:32px;
    margin-right:15px;
}
.page-title-item:hover{
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    color:#fff;
    cursor:pointer;
}
.page-mode-container{
    display: flex;
}
.page-mode-input-wrapper{
    display: flex;
    width:235px;
    position: relative;
    top:-5px;
}
.page-mode-input>>>.el-input__inner{ 
    width: 160px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right:0px !important;
}
.input-btn{
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.input-btn:hover{
    cursor:pointer;
    opacity:0.8;
}
.input-btn-icon{
    font-size: 13px;
}
.input-btn-label{
    margin-left:5px;
}
.video-list{
    margin-top:35px;
}
.view-more-btn{
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin:0 auto;
    margin-top:50px;
    margin-bottom:20px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.view-more-btn:hover{
    cursor: pointer;
    background: #F69264;
    color:#fff;
}
</style>


